var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2V8.5C12 9.2797 12.5949 9.92045 13.3555 9.99313L13.5 10H20V20C20 21.0544 19.1841 21.9182 18.1493 21.9945L18 22H6C4.94564 22 4.08183 21.1841 4.00549 20.1493L4 20V4C4 2.94564 4.81588 2.08183 5.85074 2.00549L6 2H12ZM14 2.04336C14.3222 2.11158 14.624 2.25868 14.8775 2.47305L15 2.58579L19.4142 7C19.6507 7.23647 19.8219 7.52606 19.916 7.84071L19.9566 8H14V2.04336Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.de5f92d27bd0a03acef7b2d22265e8d8.svg";
export { ForwardRef as ReactComponent };